import { css, theme } from '../lib';

export const link = css`
  color: ${theme.colors.action.navigation.standard.static};
  font-family: ${theme.fonts.primary};
  font-size: ${theme.fontSizes.md};
  font-weight: ${theme.fontWeights.regular};
  line-height: ${theme.lineHeights.none};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &[data-active='true'] {
    color: inherit;
    text-decoration: underline;
  }
`;
